export default __webpack_public_path__ + "static/media/vip12-bg.69be0f3e.jpg";